import { render, staticRenderFns } from "./PopoutGridTrims.vue?vue&type=template&id=3842144a"
import script from "./PopoutGridTrims.vue?vue&type=script&lang=js"
export * from "./PopoutGridTrims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports